import { Chip, Link, Icon } from '@nimbus-ds/components';
import { EditIcon } from '@nimbus-ds/icons';
import {
  ProductSectionResponseDto,
  ProductSectionsCodeType,
} from '@tiendanube/common';
import { Stack } from 'commons/components';
import { useAiGeneratedValues } from 'commons/hooks';
import { AI_FIELDS } from 'commons/services/AgentChatService/AgentChatActionBusTypes';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface InterfaceNameChecked {
  name: string;
  checked: boolean;
}

interface SelectedSectionsProps {
  onOpen: () => void;
  sectionsSelected: ProductSectionsCodeType[];
  sections: ProductSectionResponseDto[];
  onChange: (event: InterfaceNameChecked) => void;
}

function SelectedSections({
  onOpen,
  sectionsSelected,
  sections,
  onChange,
}: SelectedSectionsProps): JSX.Element {
  const t = useTranslationCatalog();

  const handleChange = (name: string) => onChange({ checked: false, name });

  const productHighlights = useAiGeneratedValues<string[]>(
    AI_FIELDS.PRODUCT_HIGHLIGHTS,
  );

  return (
    <Stack column align="stretch">
      <Stack>
        {sections
          .filter((section) => sectionsSelected.includes(section.code))
          .map((section, index) => (
            <Chip
              key={index}
              id={section.code}
              text={section.name}
              removable
              onClick={() => handleChange(section.code)}
              aiGenerated={productHighlights.aiGeneratedValues?.includes(
                section.code,
              )}
            />
          ))}
      </Stack>
      <Link appearance="primary" onClick={onOpen}>
        <Icon source={<EditIcon />} color="primary-interactive" />
        {t('products.detail.highlight.editSelected')}
      </Link>
    </Stack>
  );
}

export default SelectedSections;
